import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-sidebar sidebar-dark-primary elevation-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-lock mr-2 ml-3" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "brand-text font-weight-light" }, "Seguridad Helpharma", -1)
const _hoisted_4 = { class: "sidebar" }
const _hoisted_5 = { class: "user-panel mt-3 pb-3 mb-3 d-flex" }
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "user-panel mt-2" }
const _hoisted_10 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}
const _hoisted_11 = { class: "user-panel mt-3 pb-3 mb-3 d-flex" }
const _hoisted_12 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_menu_item = _resolveComponent("app-menu-item")

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "brand-link"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: (_ctx.user && _ctx.user.picture) ? _ctx.user.picture : require('@/assets/img/default-profile.png'),
            class: "img-circle elevation-2",
            alt: "User Image"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.user && _ctx.user.email), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("nav", _hoisted_9, [
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
            return (_openBlock(), _createBlock(_component_app_menu_item, {
              key: index,
              menuItem: item
            }, null, 8, ["menuItem"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", _hoisted_12, [
          _createVNode(_component_app_menu_item, { menuItem: _ctx.action }, null, 8, ["menuItem"])
        ])
      ])
    ])
  ]))
}